module.exports = __webpack_public_path__ + "static/home-artist-development-af6edc26704bd5a79ac348c6ef33ce89.webp";